import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { superAdminApi } from '../api/superAdminApi';

export function useSuperAdminUsers(params) {
  return useQuery({
    queryKey: ['superadmin', 'users', params],
    queryFn: () => superAdminApi.getUsers(params),
    keepPreviousData: true,
  });
}

export function useUpdateUserStatus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, isActive }) => superAdminApi.updateUserStatus(userId, isActive),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['superadmin', 'users'] }),
  });
}

export function useDeleteUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (userId) => superAdminApi.deleteUser(userId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['superadmin', 'users'] }),
  });
}